import { loadLocalState, saveLocalState } from '@/utils/storage'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LoginResponse } from '@/services/mutations/sign-in/use-sign-in'
// import { UserState } from './userTypes';

export interface UserState {
  token: string | null
  isAuthenticated: boolean
}

const initialState: UserState = {
  token: loadLocalState('user')?.access || null,
  isAuthenticated: loadLocalState('user')?.access ? true : false,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<LoginResponse>) => {
      saveLocalState('user', {
        ...action.payload,
      })
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.access,
        ...action.payload,
      }
    },
    // Action to handle user logout
    logout: (state) => {
      localStorage.removeItem('user')
      return {
        ...state,
        isAuthenticated: false,
        token: null,
        access: null,
        refresh: null,
      }
    },
    refresToken: (state, action: PayloadAction<string>) => {
      // Merge into the stored session, not the Redux state: after a page reload
      // the state holds no refresh token, and overwriting with it would drop it.
      saveLocalState('user', {
        ...loadLocalState('user'),
        access: action.payload,
      })
      return {
        ...state,
        token: action.payload,
      }
    },
  },
})

export const { login, logout, refresToken } = userSlice.actions

export default userSlice.reducer
